var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{class:_vm.$style.overlay,attrs:{"value":_vm.showLoader}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#2C4F7A"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }